<template>
  <section v-if="loaded">
    <drag
      class="order-drag__wrapper"
      :list="ordersSpeaker"
      :options="{draggable:'.item'}"
      @update="onUpdate"
    >
      <v-card
        v-for="(speaker, i) in ordersSpeaker"
        :key="`speakers-orders-${i}`"
        class="item my-2 mx-4 order-drag"
      >
        <v-card-title class="title">
          name: {{speaker.name}}
        </v-card-title>
        <v-card-media :src="speaker.image" height="100px">
        </v-card-media>
        <v-card-text>
          company: {{speaker.company}}
        </v-card-text>
        <v-card-text class="text-xs-right">
          order: {{speaker.order}}
        </v-card-text>
      </v-card>
    </drag>
    <v-flex class="mt-5 text-xs-right">
      <v-btn
        color="success"
        @click="changeOrder"
        :disabled="!isWriteAvailable"
      >
        Save
      </v-btn>
    </v-flex>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { clone, pick, map, sortWith, ascend, prop } from 'ramda'
  import mixins from '@/utils/mixins'

  export default {
    name: 'speakers-orders',
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        loaded: false,
        ordersSpeaker: [],
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'speakers:write'
      }
    },
    computed: {
      ...mapGetters(['getSpeakers'])
    },
    watch: {
      getSpeakers () {
        const order = clone(this.getSpeakers)

        // function compare (a, b) {
        //   if (a.order < b.order) return -1
        //   if (a.order > b.order) return 1
        //   return 0
        // }
        // const orderSort = order.sort(compare)
        const filterDeletedSpeakers = order.filter(speaker => speaker.status !== 'Deleted')
        const orderSort = sortWith([
          ascend(prop('order')),
          ascend(prop('name'))
        ])(filterDeletedSpeakers)

        this.loaded = true
        this.ordersSpeaker = orderSort
      }
    },
    methods: {
      ...mapActions([
        'patchOrdersSpeaker',
        'fetchSpeakersList'
      ]),
      async get () {
        await this.fetchSpeakersList()
      },
      onUpdate () {
        this.ordersSpeaker = this.ordersSpeaker.map((speaker, speakerIndex) => {
          speaker.order = speakerIndex + 1
          return speaker
        })
      },
      changeOrder () {
        const speakers = map(val => pick(['id', 'order'], val), this.ordersSpeaker)
        let i = 1
        map(val => val.order = i++, speakers)
        this.patchOrdersSpeaker(speakers)
        this.get()
      }
    },
    created () {
      this.get()
    }
  }
</script>

<style lang="scss" scoped>
  .order-drag__wrapper {
    display: flex;
    flex-wrap: wrap;

    .order-drag {
      width: 300px;
      padding: 10px 20px;
    }
  }

  .sortable-ghost {
    opacity: 0.3;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Speakers/Orders/index.vue